import { render, staticRenderFns } from "./OperationsCompare.vue?vue&type=template&id=2a89746e"
import script from "./OperationsCompare.vue?vue&type=script&lang=js"
export * from "./OperationsCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports